/** LaunchDarkly flag key (dashboard). */
export const LAUNCHDARKLY_FLAG_KEYS = {
  /**
   * Gates the complete Slice 6 experience: home, signup role, integrator
   * requests, sandbox credentials, Markdoc docs, and API Reference.
   * OFF / unavailable → current main experience (fail-closed).
   * Local (LD disabled) defaults to ON.
   */
  sandboxCredentials: "api-portal-sandbox-credentials",
  /**
   * Gates the ABC Fitness Developer Platform landing at `/portal`.
   * OFF / unavailable → `#/` and `/portal` redirect to Glofox docs (fail-closed).
   * Local (LD disabled) defaults to OFF.
   */
  multiPlatformDocs: "api-portal-multi-platform-docs",
} as const;

/** camelCase key returned by `useFlags()` for kebab-case flag names. */
export const LD_SANDBOX_CREDENTIALS_FLAG = "apiPortalSandboxCredentials" as const;

/** camelCase key returned by `useFlags()` for `api-portal-multi-platform-docs`. */
export const LD_MULTI_PLATFORM_DOCS_FLAG = "apiPortalMultiPlatformDocs" as const;
